import { c } from '../../utils/tailwind-merge';
import { ChipList } from '../ChipList/ChipList';
import type { RelatedKeywordsProps } from './types';

const baseClasses = 'mt-8';

export const RelatedKeywords = ({
  items,
  link,
  onClick,
  className,
  microcopy,
}: RelatedKeywordsProps) => {
  return (
    <div className={c('w-full', className ? className : '')}>
      <h3 className="text-md font-medium text-grey-900">{microcopy.title}</h3>
      <div className={c(baseClasses, 'mb-16')}>
        <ChipList
          items={items}
          link={link}
          onClick={onClick}
          className={className}
        />
      </div>
    </div>
  );
};
